import { render, staticRenderFns } from "./admin-header-new.vue?vue&type=template&id=3283afce"
import script from "./admin-header-new.vue?vue&type=script&lang=js"
export * from "./admin-header-new.vue?vue&type=script&lang=js"
import style0 from "./admin-header-new.vue?vue&type=style&index=0&id=3283afce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports